import { render, staticRenderFns } from "./DevelopmentGuidanceDetail.vue?vue&type=template&id=ccdb125a&scoped=true&"
import script from "./DevelopmentGuidanceDetail.vue?vue&type=script&lang=js&"
export * from "./DevelopmentGuidanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentGuidanceDetail.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./DevelopmentGuidanceDetail.vue?vue&type=style&index=1&id=ccdb125a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdb125a",
  null
  
)

export default component.exports